type CatalogPayload = {
  params?: Record<string, unknown>;
  config?: Record<string, unknown>;
};

export const readCatalogPayload = (): CatalogPayload => {
  const dataElement = document.getElementById('catalog-payload');
  if (!dataElement) {
    return {};
  }

  try {
    return JSON.parse(dataElement.textContent || '{}') as CatalogPayload;
  } catch {
    return {};
  }
};
